import React, { createContext, useContext } from 'react';
import type {
  ATColumnType,
  ATFilterCtxType,
  ATContextProviderProps,
} from './types';

const ATFilterContext = createContext<ATFilterCtxType<any>>({
  filterValue: '',
  filterCols: [],
  setFilterValue: () => null,
  setFilterCols: () => null,
});

export const useATFilter = (): ATFilterCtxType<any> => {
  const ctx = useContext(ATFilterContext);
  if (ctx === null) {
    throw new Error('useATFilter must be used within a ATFilterProvider');
  }
  return ctx;
};

export const ATFilterContextProvider: React.FC<ATContextProviderProps> = ({
  children,
}) => {
  const [filterValue, setFilterValue] = React.useState<string>('');
  const [filterCols, setFilterCols] = React.useState<ATColumnType<any>[]>([]);

  const value = React.useMemo(
    () => ({
      filterValue,
      setFilterValue,
      filterCols,
      setFilterCols,
    }),
    [filterValue, filterCols],
  );

  return (
    <ATFilterContext.Provider value={value}>
      {children}
    </ATFilterContext.Provider>
  );
};
